import AdminLayout from '@/layouts/AdminLayout';
import Dashboard from '@/views/admin/Dashboard';
import BusinessType from '@/views/admin/businesses/type/List';
import Business from '@/views/admin/businesses/List';
import ProductType from '@/views/admin/products/type/List';
import Product from '@/views/admin/products/List';
import ProductChain from '@/views/admin/products/chain/List';
import Coope from '@/views/admin/products/coope/List';
import WareHouse from '@/views/admin/products/warehouse/List';
import NewsType from '@/views/admin/news/type/List';
import News from '@/views/admin/news/List';
import NewsImport from '@/views/admin/news/Import';
import MarketProdGroup from '@/views/admin/markets/products/groups/List';
import MarketProdType from '@/views/admin/markets/products/types/List';
import MarketProduct from '@/views/admin/markets/products/List';
import MarketPrice from '@/views/admin/markets/List';
import MarketImport from '@/views/admin/markets/Import';
import Statistic from '@/views/admin/markets/Statistic';
import System from '@/views/admin/systems/List';
import WebLink from '@/views/admin/systems/web_link/List';
import Changelog from '@/views/admin/systems/changelogs/List';
import User from '@/views/admin/users/acl/List';
import Permission from '@/views/admin/users/acl/permissions/List';
import Role from '@/views/admin/users/acl/roles/List';
import ActivityLog from '@/views/admin/users/log/List';
import Expert from '@/views/admin/supports/expert/List';
import SupportBranch from '@/views/admin/supports/branch/List';
import Support from '@/views/admin/supports/List';
import CallCenter from '@/views/admin/supports/callcenter/List';
import MissCall from '@/views/admin/supports/miss_call/List';
import Contact from '@/views/admin/contacts/List';
import Image from '@/views/admin/images/List';
import Management from '@/views/admin/managements/List';
import Report from '@/views/admin/reports/Form';
import BugStat from '@/views/admin/reports/statistic/Bug';
import Import from '@/components/common/Import';
import Province from '@/views/admin/regions/province/List';
import Ward from '@/views/admin/regions/ward/List';
import District from '@/views/admin/regions/district/List';
import Option from '@/views/admin/options/List';
import Backup from '@/views/admin/backup/List';
import FakeStat from '@/views/admin/fake_stats/List';
import Trade from '@/views/admin/trades/List';
import SyncData from '@/views/admin/sync_data/List';

const routes = [
  {
    path: '/admin',
    component: AdminLayout,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: "Tổng quan"
    },
    children: [
      {
        path: '/',
        redirect: { name: 'Dashboard' }
      },
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'Dashboard'
      },
      {
        path: 'business-types',
        component: BusinessType,
        name: 'BusinessType'
      },
      {
        path: 'businesses',
        component: Business,
        name: 'AdminBusiness'
      },
      {
        path: 'business/:show',
        component: Business,
        name: 'BusinessShow'
      },
      {
        path: 'product-types',
        component: ProductType,
        name: 'ProductType'
      },
      {
        path: 'products',
        component: Product,
        name: 'AdminProduct'
      },
      {
        path: 'product-chains',
        component: ProductChain,
        name: 'AdminProductChain'
      },
      {
        path: 'product/:show',
        component: Product,
        name: 'ProductShow'
      },
      {
        path: 'post-types',
        component: NewsType,
        name: 'NewsType'
      },
      {
        path: 'news',
        component: News,
        name: 'AdminNews'
      },
      {
        path: 'coopes',
        component: Coope,
        name: 'Coope'
      },
      {
        path: 'activity-logs',
        component: ActivityLog,
        name: 'ActivityLog'
      },
      {
        path: 'market-products',
        component: MarketProduct,
        name: 'MarketProduct'
      },
      {
        path: 'market-prod-groups',
        component: MarketProdGroup,
        name: 'MarketProdGroup'
      },
      {
        path: 'market-prod-types',
        component: MarketProdType,
        name: 'MarketProdType'
      },
      {
        path: 'market-prices',
        component: MarketPrice,
        name: 'AdminMarketPrice'
      },
      {
        path: 'market-import',
        component: MarketImport,
        name: 'MarketImport'
      },
      {
        path: 'market-statistic',
        component: Statistic,
        name: 'Statistic'
      },
      {
        path: 'system',
        component: System,
        name: 'System'
      },
      {
        path: 'web-links',
        component: WebLink,
        name: 'WebLink'
      },
      {
        path: 'changelogs',
        component: Changelog,
        name: 'Changelog'
      },
      {
        path: 'users',
        component: User,
        name: 'User'
      },
      {
        path: 'permissions',
        component: Permission,
        name: 'Permission'
      },
      {
        path: 'roles',
        component: Role,
        name: 'Role'
      },
      {
        path: 'supports',
        component: Support,
        name: 'AdminSupport'
      },
      {
        path: 'calls',
        component: CallCenter,
        name: 'CallCenter'
      },
      {
        path: 'support-branch',
        component: SupportBranch,
        name: 'SupportBranch'
      },
      {
        path: 'experts',
        component: Expert,
        name: 'AdminExpert'
      },
      {
        path: 'misscalls',
        component: MissCall,
        name: 'MissCall'
      },
      {
        path: 'contacts',
        component: Contact,
        name: 'Contact'
      },
      {
        path: 'images',
        component: Image,
        name: 'Image'
      },
      {
        path: 'managements',
        component: Management,
        name: 'Management'
      },
      {
        path: 'reports',
        component: Report,
        name: 'Report'
      },
      {
        path: 'report/bugstat',
        component: BugStat,
        name: 'BugStat'
      },
      {
        path: 'import/:type',
        component: Import,
        name: 'Import'
      },
      {
        path: 'news-import',
        component: NewsImport,
        name: 'NewsImport'
      },
      {
        path: 'unit/province',
        component: Province,
        name: 'Province'
      },
      {
        path: 'unit/ward',
        component: Ward,
        name: 'Ward'
      },
      {
        path: 'unit/district',
        component: District,
        name: 'District'
      },
      {
        path: 'options',
        component: Option,
        name: 'Option'
      },
      {
        path: 'backup',
        component: Backup,
        name: 'Backup'
      },
      {
        path: 'warehouses',
        component: WareHouse,
        name: 'WareHouse'
      },
      {
        path: 'fake-stats',
        component: FakeStat,
        name: 'FakeStat'
      },
      {
        path: 'trades',
        component: Trade,
        name: 'TradeAdmin'
      },
      {
        path: 'sync-data',
        component: SyncData,
        name: 'SyncData'
      }
    ],
  }
];

export default routes;